import { Box } from '@mui/material'
import { memo } from 'react'

import { MrtMobileCardSkeleton } from './MrtMobileCardSkeleton.tsx'

export interface MrtMobileLoadingOverlayProps {
  /**
   * Número de tarjetas skeleton.
   */
  count?: number
  /**
   * Número de campos simulados por tarjeta.
   */
  fields?: number
  /**
   * Número de columnas del summary.
   */
  columns?: number
}

function MrtMobileLoadingOverlayComponent({
  count = 4,
  fields = 4,
  columns = 2,
}: MrtMobileLoadingOverlayProps) {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        overflow: 'hidden',
      }}
    >
      {Array.from({
        length: count,
      }).map((_, index) => (
        <MrtMobileCardSkeleton key={index} fields={fields} columns={columns} />
      ))}
    </Box>
  )
}

export const MrtMobileLoadingOverlay = memo(MrtMobileLoadingOverlayComponent)

export default MrtMobileLoadingOverlay
